'use strict';
angular.module('components.utils', [
    'util.trsSingleSelection',
    'util.trsSingleSelectionCheckbox',
    'util.checkbox',
    'httpServiceModule',
    'suggestionModule',
    'trsRadioModule',
    'validationRuleModule',
    'angularPlusModule',
    'trsSwitchModule',
    'circulationDomModule',
    'selectUsersServiceModule',
    'trsTransferModule', //组织树
    'trsSceModule',
    'imgautoModule',
    'trsModalDialog',
    'newPageScrollPicModule',
    'publicFooterModule',
    'trsHeightModule',
    'trsTimeSelectModule',
    'trsspliceStringModule',
    'trsPagenationConfigLeftModule',
    'trsPagenationConfigRightModule',
    'util.trsScrollPicturesModule',
    'util.trsSingleRadio',
    'util.trsSingleSelection',
    'util.btnDisabled',
    'util.trsWordNum',
    'trsMasUploadDirective',
    'util.ueditor',
    'trsTimepicker',
    'trsStartEndTimeModule',
    'provinceAndCitiesModule',
    'trsTooltipModule',
    'trsPreviewTitleModule',
    'trsZjolUploadDirective',
    'uploadToZjolServiceModule',
    'editPictureServiceModule', //图片编辑
    'util.dateSlider', //活动详情页时间轴滑块
    'checkPhoneAndEmail',
    'ngModelFixModule',
    'atlasCarouselModule',
    'playVideoServiceModule',
    'queryVideoAndAudioModule',
    'leftLiWidthModule',
    'playAudioModule',
    'trsUploadForXjModule', // 上传指令
    'classicListTwoLevelDirective', //二级选择指令
    'selectiveOrganizationServiceModule',
    'picsPreviewRebuildModule'
]);
